import { IPatchUserBody } from '@types';
import { AxiosError, AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';

// 어드민 - 회원 수정
async function patchUser(variables: {
  body: IPatchUserBody;
  userId?: string;
}): Promise<AxiosResponse<FetchResult<string>>> {
  const response = await instance.patch(`/users/${variables.userId}`, variables.body);
  return response;
}

const usePatchUser = (
  onSuccess?: (data: AxiosResponse<FetchResult<string>>) => void,
  onError?: (err: AxiosError) => void
) => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['patch', `/users/:id`],
    mutationFn: (variables: { body: IPatchUserBody; userId?: string }) => patchUser(variables),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      onError?.(err);
    },
    retry: false
  });

  return { mutateAsync, isPending };
};

export default usePatchUser;
